import { __assign, __rest } from "tslib";
import React from "react";
import { View, Text } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacRowItem.styles.js";
var PnmacRowItem = function (_a) {
  var rowTitleStyles = _a.rowTitleStyles,
    rowContainerStyles = _a.rowContainerStyles,
    title = _a.title,
    Component = _a.renderChildren,
    rest = __rest(_a, ["rowTitleStyles", "rowContainerStyles", "title", "renderChildren"]);
  return /*#__PURE__*/React.createElement(View, {
    style: __assign(__assign({}, styles.rowContainerStyles), rowContainerStyles),
    testID: "rowItem"
  }, !Component ? (/*#__PURE__*/React.createElement(Text, {
    style: __assign(__assign({}, styles.rowTitleStyles), rowTitleStyles)
  }, title)) : (/*#__PURE__*/React.createElement(Component, null)));
};
PnmacRowItem.propTypes = {
  title: PropTypes.string,
  rowContainerStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  renderChildren: PropTypes.func,
  rowTitleStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string])
};
export default PnmacRowItem;